/* eslint-disable */

const form1 = {
    "id": "info_course",
    "name": "Informations pour la course",
    "description": "Veuillez répondre aux questions suivantes pour être éligible à la course.",
    "hasAutoFillInfo": true,
    "indentation": 1,
    "orderByPriceName": [
        "Prévente 10KM (16 ans et plus)",
        "Prévente 5KM (13 ans et plus)",
        "Prévente 1KM (12 ans et moins)"
    ],
    "fields": [
        {
            "name": "priceName",
            "label": "Épreuve",
            "type": "STRING",
            "isRequired": true,
            "editable": false
        },
        {
            "name": "firstName",
            "label": "Prénom",
            "type": "STRING",
            "isRequired": true,
            "autoFillField": "profile.firstName",
            "example": "Bibi"
        },
        {
            "name": "lastName",
            "label": "Nom",
            "type": "STRING",
            "isRequired": true,
            "autoFillField": "profile.lastName",
            "example": "Grenier"
        },
        {
            "name": "genderBefore2010",
            "label": "Genre avant 2010",
            "type": "ONEOF",
            "possibleValues": [ { label: "Homme", value: "MALE" }, { label: "Femme", value: "FEMALE" }],
            "isRequired": true
        },
        {
            "name": "gender",
            "label": "Genre",
            "type": "ONEOF",
            "possibleValues": [ { label: "Homme", value: "MALE" }, { label: "Femme", value: "FEMALE" }, { label: "Transgenre", value: "TRANSGENDER" }, { label: "Bi", value: "BI" }, { label: "Gender-fluid", value: "GENDERFLUID" }, { label: "Non-Binary", value: "NONBINARY" }, { label: "Don't know yet", value: "DONTKNOW" }, { label: "Bear", value: "BEAR" }, { label: "Extra-terrestrial", value: "ET" } ],
            "isRequired": true
        },
        {
            "name": "birthdate",
            "label": "Date de naissance",
            "type": "BIRTHDATE",
            "isRequired": true
        },
        {
            "name": "email",
            "label": "Adresse courriel",
            "type": "EMAIL",
            "isRequired": true,
            "autoFillField": "profile.email",
            "helpText": "Un email de confirmation vous sera envoyé."
        },
        {
            "name": "phone",
            "label": "Téléphone",
            "type": "STRING",
            "isRequired": true,
            "autoFillField": "profile.phone"
        },
        {
            "name": "postalcode",
            "label": "Code postal",
            "type": "POSTALCODE",
            "isRequired": true,
            "autoFillField": "profile.postalcode",
            "helpText": "Ex: G5H 1J4"
        },
        {
            "name": "namePersonEmergency",
            "label": "Nom de la personne en cas d’urgence",
            "type": "JSON",
            "isRequired": true
        },
        {
            "name": "medicalProblem",
            "label": "Problème médical",
            "type": "JSON"
        },
        {
            "name": "otherInfos",
            "label": "Autre infos",
            "type": "JSON",
            "isRequired": true,
            "example": "{\"name\": \"Bibi Grenier\", \"age\": 175 }"
        },
        {
            "name": "peopleCount",
            "label": "Nombre de personnes",
            "type": "INT",
            "min": 1,
            "max": 100,
            "maxlength": 3
        },
        
        {
            "name": "PackageIDs",
            "label": "Forfaits",
            "type": "MULTIPLE_VALUES",
            "field": {
                "name": "packageID",
                "label": "ID du forfait",
                "type": "INT",
                "isRequired": true
            },
        },
        {
            "name": "PromoSuggestion",
            "label": "Promotions",
            "type": "MULTIPLE_DOCUMENTS",
            "previewFields": [ "name", "link" ],
            "fields": [
                {
                    "name": "name",
                    "label": "Nom",
                    "type": "STRING",                 
                },
                {
                    "name": "link",
                    "label": "Lien",
                    "type": "MULTIPLE_VALUES",
                    "field": {
                        "name": "link",
                        "label": "Lien",
                        "type": "STRING"
                    },          
                },
                {
                    "name": "messageFr",
                    "label": "Message (fr)",
                    "type": "STRING",                 
                },
                {
                    "name": "messageEn",
                    "label": "Message (en)",
                    "type": "STRING",                 
                }
            ]

        },
        {
            "name": "receivePromoEmails",
            "label": "Je veux recevoir des courriels de promotion",
            "type": "BOOL",
            "choices": {
                trueText: "Oui",
                falseText: "Non"
            } // si choices absent, case a coché, sinon deux radiobutton avec trueText/falsText
        },

        {
            "name": "howHeardOfUs",
            "label": "Comment avez-vous entendu parler de notre événement?",
            "type": "TAGS",
            "possibleValues": [
                {
                    label: "Facebook / Instagram", 
                    value: "socialMedia" 
                },
                {
                    label: "Radio",
                    value: "radio"
                },
                {
                    label: "Un ami",
                    value: "friend"
                },
                {
                    label: "Autre (veuillez préciser)",
                    value: "other"
                },
            ]
        }
    ]
};
const form2 = {
    "id": "info_course",
    "name": {
        "fr": "Informations pour la course",
        "en": "Run informations"
    },
    "description": {
        "fr": "Veuillez répondre aux questions suivantes pour être éligible à la course.",
        "en": "Please answer questions below to be eligible for the run."
    },
    "hasAutoFillInfo": true,
    "indentation": 1,
    "orderByPriceName": [
        "Prévente 10KM (16 ans et plus)",
        "Prévente 5KM (13 ans et plus)",
        "Prévente 1KM (12 ans et moins)"
    ],
    "fields": [
        {
            "name": "priceName",
            "label": {
                "fr": "Épreuve",
                "en": "Trial"
            },
            "type": "STRING",
            "isRequired": true,
            "editable": false
        },
        {
            "name": "firstName",
            "label": {
                "fr": "Prénom",
                "en": "First name"
            },
            "type": "STRING",
            "isRequired": true,
            "autoFillField": "profile.firstName",
            "example": "Bibi"
        },
        {
            "name": "lastName",
            "label": {
                "fr": "Nom",
                "en": "Last name"
            },
            "type": "STRING",
            "isRequired": true,
            "autoFillField": "profile.lastName",
            "example": "Grenier"
        },
        {
            "name": "genderBefore2010",
            "label": {
                "fr": "Genre avant 2010",
                "en": "Before 2010's gender"
            },
            "type": "ONEOF",
            "possibleValues": [ { label: { "fr": "Homme", "en": "Male" }, value: "MALE" }, { label: { "fr": "Femme", "en": "Female" }, value: "FEMALE" }],
            "isRequired": true
        },
        {
            "name": "gender",
            "label": "Genre",
            "type": "ONEOF",
            "possibleValues": [ { label: { "fr": "Homme", "en": "Male" }, value: "MALE" }, { label: { "fr": "Femme", "en": "Female" }, value: "FEMALE" }, { label: { "fr": "Transgenre", "en": "Transgender" }, value: "TRANSGENDER" }, { label: { "fr": "Bi", "en": "Bi" }, value: "BI" }, { label: { "fr": "Gender-fluid",  "en": "Gender-fluid"}, value: "GENDERFLUID" }, { label: { "fr": "Non binaire", "en": "Non-Binary" }, value: "NONBINARY" }, { label: { "fr": "Ne sais pas", "en": "Don't know yet" }, value: "DONTKNOW" }, { label: { "fr": "Ours", "en": "Bear" }, value: "BEAR" }, { label: { "fr": "Extra-terrestre", "en": "Extra-terrestrial" }, value: "ET" } ],
            "isRequired": true
        },
        {
            "name": "birthdate",
            "label": { 
                "fr": "Date de naissance", 
                "en": "Birthday date" 
            },
            "type": "BIRTHDATE",
            "isRequired": true
        },
        {
            "name": "email",
            "label": { 
                "fr": "Adresse courriel", 
                "en": "Email" 
            },
            "type": "EMAIL",
            "isRequired": true,
            "autoFillField": "profile.email",
            "helpText": { 
                "fr": "Un email de confirmation vous sera envoyé.",
                "en": "A confirmation email will be sent to you."
            }
        },
        {
            "name": "phone",
            "label": { 
                "fr": "Téléphone", 
                "en": "Phone" 
            },
            "type": "STRING",
            "isRequired": true,
            "autoFillField": "profile.phone"
        },
        {
            "name": "postalcode",
            "label": { 
                "fr": "Code postal", 
                "en": "Postal code" 
            },
            "type": "POSTALCODE",
            "isRequired": true,
            "autoFillField": "profile.postalcode",
            "helpText": "Ex: G5H 1J4"
        },
        {
            "name": "namePersonEmergency",
            "label": { 
                "fr": "Nom de la personne en cas d'urgence", 
                "en": "Contact name in case of urgency" 
            },
            "type": "JSON",
            "isRequired": true,
            "example": "{\r\n    \"name\": \"Bibi Grenier\", \r\n    \"age\": 175 \r\n}"
        },
        {
            "name": "medicalProblem",
            "label": { 
                "fr": "Problème médical", 
                "en": "Health issue" 
            },
            "type": "JSON"
        },
        {
            "name": "peopleCount",
            "label": { 
                "fr": "Nombre de personnes", 
                "en": "Participants number" 
            },
            "type": "INT",
            "min": 1,
            "max": 100,
            "maxlength": 3
        },
        {
            "name": "PackageIDs",
            "label": { 
                "fr": "Forfaits", 
                "en": "Packages" 
            },
            "type": "MULTIPLE_VALUES",
            "field": {
                "name": "packageID",
                "label": { 
                    "fr": "ID du forfait", 
                    "en": "Package ID" 
                },
                "type": "INT",
                "isRequired": true
            },
        },
        {
            "name": "PromoSuggestion",
            "label": { 
                "fr": "Promotions", 
                "en": "Promotions" 
            },
            "type": "MULTIPLE_DOCUMENTS",
            "previewFields": [ "name", "link" ],
            "fields": [
                {
                    "name": "name",
                    "label": { 
                        "fr": "Nom", 
                        "en": "Name" 
                    },
                    "type": "STRING",                 
                },
                {
                    "name": "link",
                    "label": { 
                        "fr": "Lien", 
                        "en": "Link" 
                    },
                    "type": "MULTIPLE_VALUES",
                    "field": {
                        "name": "link",
                        "label": { 
                            "fr": "Lien", 
                            "en": "Link" 
                        },
                        "type": "STRING"
                    },          
                },
                {
                    "name": "message",
                    "label": { 
                        "fr": "Message", 
                        "en": "Message" 
                    },
                    "label": "Message",
                    "type": "JSON",                 
                }
            ]
        },
        {
            "name": "receivePromoEmails",
            "label": { 
                "fr": "Je veux recevoir des courriels de promotion", 
                "en": "I want to receive promotional emails" 
            },
            "type": "BOOL",
            "choices": {
                trueText: { 
                    "fr": "Oui", 
                    "en": "Yes" 
                },
                falseText: { 
                    "fr": "Non", 
                    "en": "No"
                },
            } // si choices absent, case a coché, sinon deux radiobutton avec trueText/falsText
        },
        {
            "name": "testAnotherBool",
            "label": { 
                "fr": "Est-ce que je fonctionne avec un autre BOOL dans le même form?", 
                "en": "Do I work with another BOOL in same form?" 
            },
            "type": "BOOL",
            "choices": {
                trueText: { 
                    "fr": "Oui", 
                    "en": "Yes" 
                },
                falseText: { 
                    "fr": "Non", 
                    "en": "No"
                },
            } // si choices absent, case a coché, sinon deux radiobutton avec trueText/falsText
        },
        {
            "name": "howHeardOfUs",
            "label": { 
                "fr": "Comment avez-vous entendu parler de notre événement?", 
                "en": "How did you hear about our event?" 
            },
            "type": "TAGS",
            "possibleValues": [
                {
                    label: { 
                        "fr": "Facebook / Instagram", 
                        "en": "Facebook / Instagram"
                    },
                    value: "socialMedia" 
                },
                {
                    label: { 
                        "fr": "Radio", 
                        "en": "Radio" 
                    },
                    value: "radio"
                },
                {
                    label: { 
                        "fr": "Un ami", 
                        "en": "A friend" 
                    },
                    value: "friend"
                },
                {
                    label: { 
                        "fr": "Autre (veuillez préciser)", 
                        "en": "Other (please tell us)" 
                    },
                    value: "other",
                    subField: "howHeardOfUsOther"
                }
            ]
        },
        {
            name: "howHeardOfUsOther",
            type: "STRING",
            isRequired: true,
            isSubField: true
        }
    ]
};

export default {
    form1: form1,
    form2: form2,
    "ticketForms": [ form1 ] // Legacy name. To remove this, make sure no other projects use it in their demo
};
